import { paymentsApiRoutes as routes } from './routes';
export function getPaymentsApiV1(httpClient) {
    return {
        masterData: {
            webPaymentMethods: {
                get: query => httpClient.get(routes.masterData.webPaymentMethods.get(), { queryParams: query })
            }
        }
    };
}
//# sourceMappingURL=get-payments-api.js.map